
export const environment = {
  production: false,
  sendExternalEmail: false,
  msGraphUrl: "https://graph.microsoft.com/v1.0/",
   APPLICATIONINSIGHTS_CONNECTION_STRING: getInstrumentationKey(),
};

function getInstrumentationKey() {
  switch (process.env.cvx_environment_name) {
    case "prod":
      return "InstrumentationKey=41f2f2b4-72b7-416f-8467-65ba1456fd88";
    case "test":
      return "InstrumentationKey=3ee0f01e-475d-45bc-997b-e4cc079447da";
    case "dev":
      return "InstrumentationKey=1727de81-9836-4f18-b37d-077369f8006a";
    case "local":
      return "InstrumentationKey=1727de81-9836-4f18-b37d-077369f8006a";
    default:
      return "InstrumentationKey=1727de81-9836-4f18-b37d-077369f8006a";
  }
}